module.exports = __webpack_public_path__ + "img/red_023.5f8fd242.png";